import { Injectable } from '@angular/core';

import { GraphQLService, DataService } from '@app/services';
import { 
    mutationLogin, mutationPreviewLogin, mutationRequestPasswordRecovery, mutationValidatePasswordRecovery, mutationSignup, mutationUpdate, queryMe
} from '@app/graphql-queries';
import { Ambassador, LeadSignup, AmbassadorUpdate } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class AmbassadorService {
    
    constructor(
        private graphQLService: GraphQLService,
        private dataService: DataService
    ) { }
    
    async login(email: string, password: string, rememberMe: boolean): Promise<any|null>{        
        let ambassador: any|null = null;
        let operation = this.dataService.operation.value;
        if(operation){
            let response = await this.graphQLService.mutate({            
                mutation: mutationLogin,
                variables: {
                    operationID: operation.ID,
                    email: email,
                    password: password,
                    rememberMe: rememberMe,
                }
            }, 'public');              
            if(response?.data?.AmbassadorLogin){
                 ambassador = response.data.AmbassadorLogin;
            }
        }
        return ambassador;
    }
    
    async loginPreview(operationID: string, ambassadorPreviewID: string){       
        let response = await this.graphQLService.mutate({
            mutation: mutationPreviewLogin,
            variables: {
                operationID: operationID,
                ID: ambassadorPreviewID
            }
        }, 'public');        
    }
    
    async requestPasswordRecovery (email: string): Promise<boolean>{
        let status: boolean = false;
        let operation = this.dataService.operation.value;
        if(operation){
            let response = await this.graphQLService.mutate({            
                mutation: mutationRequestPasswordRecovery,
                variables: {
                    operationID: operation.ID,
                    email: email
                }
            }, 'public');     
            if(response?.data?.AmbassadorRequestPasswordRecovery){
                status = true;
            }
        }
        return status;
    }
    
    async resetPassword(token: string, password: string): Promise<any|null>{
        let ambassador: any|null = null;
        let response = await this.graphQLService.mutate({            
            mutation: mutationValidatePasswordRecovery,
            variables: {
                token: token,
                password: password
            }
        }, 'public');     
        if(response?.data?.AmbassadorValidatePasswordRecovery){
            ambassador = response.data.AmbassadorValidatePasswordRecovery;
        }
        return ambassador;
    }
    
    async signup(lead: LeadSignup): Promise<{ambassador: any|null, error?: string}>{
        let data: {ambassador: any|null, error?: string} = {ambassador: null};
        let response = await this.graphQLService.mutate({   
            mutation: mutationSignup,
            variables: {
                params: JSON.stringify(lead),
            }       
        }, 'public');   
        if(response?.error){
            data.error = response.error.message;
        }
        else if(response?.data?.AmbassadorSignup?.ID){
            data.ambassador = response?.data?.AmbassadorSignup;
        }
        return data;
    }
    
    async update(ambassadorUpdate: AmbassadorUpdate): Promise<boolean>{
        let status: boolean = false;
        let response = await this.graphQLService.mutate({   
            mutation: mutationUpdate,
            variables: {
                params: JSON.stringify(ambassadorUpdate),
            }       
        });     
        if(response?.data?.Update){
            status = true;
        }
        return status;
    }
    
    async fetchAmbassador(): Promise<any|null> {
        let ambassador: any|null = null;
        let response = await this.graphQLService.query({   
            query: queryMe,
            variables: {}       
        });     
        if(response?.data?.Me?.ID){
            ambassador = response.data.Me;
        }
        return ambassador;
    }
    
    async refreshAmbassador(){
        let ambassador = await this.fetchAmbassador();
        if(ambassador){
            this.dataService.ambassador = new Ambassador(ambassador);
            this.dataService.ambassador.initChallenges(this.dataService.operation);
        }
    }
    
}
